<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
  <div class="row g-0 m-0 p-4 justify-content-start borderb">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{ "UTILITY_DETAILS" | translate }}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon class="exit" role="button" src="assets/device/exit.svg" alt="Exit"></svg-icon>
    </div>
  </div>
  <div class="row g-0 m-0 body p-4 pt-5">
    <div class="member-details p-4">
      <div class="row g-0 m-0">
        <div class="row d-flex g-0 p-0">
          <span class="item-title pb-4 pt-2">{{ utility.name }} </span>
        </div>
        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "ACRONYM" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ utility.acronym }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "CREATION_DATE" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ utility.creationDate | date: "dd MMM yyyy, h:mm a" }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "EMAIL" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ utility.contactPersonEmail }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "FIRSTNAME" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ utility.contactPersonFirstName }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "LASTNAME" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ utility.contactPersonLastName }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "PHONE_NUMBER" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ utility.contactPersonPhoneNumber }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "UTILITY_COUNTRY" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ utility.country }}</span>
          </div>
        </div>
        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "TIMEZONE" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">GMT {{ utility.timeZone! / 60 }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "UTILITY_ADDRESS" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ utility.address }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "WEBSITE_ADDRESS" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ utility.websiteAddress }}</span>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="row g-0 m-0 p-3 align-items-end bordert mt-auto">
    <div class="col-md-9 pt-2 pb-2 ps-2 d-flex justify-content-start" (click)="toggleModal()">
      <span role="button" class="item-name">{{
        "CLOSE_WINDOW" | translate
        }}</span>
    </div>
  </div>
</div>